'use client';

import { useAtomValue } from 'jotai';
import { FunctionComponent } from 'react';
import clientDeviceSize, { ScreenSize } from '../store/deviceScreenSize';
import Logo from './Logo';

interface IProps {
  className?: string
}

const FooterLogo: FunctionComponent<IProps> = ({ className }) => {
  const deviceSize = useAtomValue<ScreenSize>(clientDeviceSize);
  const logoWidth = deviceSize === ScreenSize.DESKTOP_HUGE ? 167 : 112;
  const logoHeight = deviceSize === ScreenSize.DESKTOP_HUGE ? 61 : 40;

  return (
    <Logo
      width={logoWidth}
      height={logoHeight}
      className={className}
    />
  );
};

export default FooterLogo;
